<template>
  <ul v-if="items" class="show-content-fade">
    <li
      v-for="item in items"
      :key="item.href"
      :value="item.href"
      class="items-list block w-full focus:outline-none focus:ring-0"
      :class="{ active: item.active }"
    >
      <LinksListItem :item="item" :nested-level="nestedLevel" />
    </li>
  </ul>
</template>
<script setup lang="ts">
import LinksListItem from "@/components/shared/LinksListItem.vue";

import { TocItem } from "../navigator/types";

withDefaults(
  defineProps<{
    nestedLevel?: number;
    items: Readonly<TocItem[]> | null;
  }>(),
  {
    nestedLevel: 0,
  }
);
</script>

<style lang="scss">
@use "@/assets/styles/variables.scss" as *;
.items-list {
  > button {
    border-color: var(--DM__theme-separator-color);
    border-left: 2 * $spacingXS solid transparent;
  }
  &.active,
  &:hover {
    > button {
      border-left-color: var(--DM__theme-border-color);
    }
  }
}
</style>
